
export default [
{
    path: '/admin_panel',
    name: 'AdminPanel',
    meta: { RequiresAuth: true },
    component: () => import('@/layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'AdminPanelHome', // Ensure a unique name
        component: () => import('@/views/AdminPages/AdminPanel.vue'),
      },
      {
        path: 'Classic_Tools',
        name: 'Classic_Tools',
        component: () => import('@/views/ToolsPages/Classic_Tools.vue'),
      },
      {
        path: 'manual_user_merge',
        name: 'Manual_User_Merge',
        component: () => import('@/views/ToolsPages/Manual_User_Merge.vue'),
      },
      {
        path: 'demo',
        name: 'Demo',
        component: () => import('@/views/AdminPages/Demo.vue'),
      },
      {
        path: 'upload_results_file',
        name: 'Upload_Results_File',
        component: () => import('@/views/ToolsPages/Upload_Results_File.vue'),
      },
      {
        path: 'pre_event_override',
        name: 'Pre_Event_Override',
        component: () => import('@/views/ToolsPages/Pre_Event_Override.vue'),
      },
      {
        path: 'import_results',
        name: 'Import_Results',
        component: () => import('@/views/ToolsPages/Import_Results.vue'),
      },
      {
        path: 'variable_print',
        name: 'Variable_Print',
        component: () => import('@/views/ToolsPages/Variable_Print.vue'),
      },
      {
        path: 'banner_config_tool',
        name: 'Banner_Config_Tool',
        component: () => import('@/views/ToolsPages/Banner_Config_Tool.vue'),
      },
            {
        path: 'popup_config_tool',
        name: 'Popup_Config_Tool',
        component: () => import('@/views/ToolsPages/Popup_Config_Tool.vue'),
      },
      {
        path: 'quiz_config_tool',
        name: 'Quiz_Config_Tool',
        component: () => import('@/views/ToolsPages/Quiz_Config_Tool.vue'),
      },
      {
        path: 'add_new_club',
        name: 'add_new_club',
        component: () => import('@/views/ConfigurationPages/Add_New_Club.vue'),
      },
      {
        path: 'add_new_county',
        name: 'add_new_county',
        component: () => import('@/views/ConfigurationPages/Add_New_County.vue'),
      },
      {
        path: 'add_new_admin',
        name: 'add_new_admin',
        component: () => import('@/views/ConfigurationPages/Add_New_Admin.vue'),
      },
      {
        path: 'add_new_feature_detail',
        name: 'add_new_feature_detail',
        component: () => import('@/views/ConfigurationPages/Add_New_Feature_Detail.vue'),
      },
      {
        path: 'add_new_feature',
        name: 'add_new_feature',
        component: () => import('@/views/ConfigurationPages/Add_New_Feature.vue'),
      },
      {
        path: 'add_new_federation',
        name: 'add_new_federation',
        component: () => import('@/views/ConfigurationPages/Add_New_Federation.vue'),
      },
      {
        path: 'add_new_membership',
        name: 'add_new_membership',
        component: () => import('@/views/ConfigurationPages/Add_New_Membership.vue'),
      },
      {
        path: 'edit_club',
        name: 'edit_club',
        component: () => import('@/views/ConfigurationPages/Edit_Club.vue'),
      },
      {
        path: 'edit_county',
        name: 'edit_county',
        component: () => import('@/views/ConfigurationPages/Edit_County.vue'),
      },
      {
        path: 'add_new_player',
        name: 'add_new_player',
        component: () => import('@/views/ToolsPages/Add_New_Player.vue'),
      },
    ],
  }]